import { ReactNode } from 'react';
// icons
import { ReactComponent as UserIcon } from './../../../assets/icons/user-icon.svg';
import { ReactComponent as UserActiveIcon } from './../../../assets/icons/userActive-icon.svg';
import { ReactComponent as UsersIcon } from './../../../assets/icons/users-icon.svg';
import { ReactComponent as SuitCase } from './../../../assets/icons/suitCase-icon.svg';
import { ReactComponent as SuitCaseActive } from './../../../assets/icons/suitCaseActive-icon.svg';
import { ReactComponent as AlertIcon } from './../../../assets/icons/alert-icon.svg';
import { ReactComponent as AlertActiveIcon } from './../../../assets/icons/alertActive-icon.svg';

export interface MenuItem {
    link?: string;
    icon?: ReactNode;
    activeIcon?: ReactNode;
    badge?: string;
    items?: MenuItem[];
    name: string;
    isMain?: boolean;
    secret?: number;
}

export interface MenuItems {
    items: MenuItem[];
    heading: string;
}

const menuItems: MenuItems[] = [
    {
        heading: 'Customers',
        items: [
            {
                name: 'Customers',
                link: '/customer',
                icon: UsersIcon,
                isMain: true,
                items: [
                    {
                        name: 'Accounts',
                        link: '/customer/accounts',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 6,
                    },
                    {
                        name: 'Bookings',
                        link: '/customer/bookings',
                        icon: SuitCase,
                        activeIcon: SuitCaseActive,
                        secret: 5,
                    },
                ],
            },
        ],
    },
    {
        heading: 'Operations',
        items: [
            {
                name: 'Operations',
                link: '/operations',
                icon: UsersIcon,
                isMain: true,
                items: [
                    {
                        name: 'Booking Summary',
                        link: '/operations/booking-summary',
                        icon: SuitCase,
                        activeIcon: SuitCaseActive,
                        secret: 11,
                    },
                    {
                        name: 'Driver Summary',
                        link: '/operations/driver-summary',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 12,
                    },
                    {
                        name: 'Flight Summary',
                        link: '/operations/flight-summary',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 17,
                    },
                    {
                        name: 'Incidents',
                        link: '/operations/incidents',
                        icon: AlertIcon,
                        activeIcon: AlertActiveIcon,
                        secret: 19,
                    },
                ],
            },
        ],
    },
    {
        heading: 'Admin',
        items: [
            {
                name: 'Admin',
                link: '/admin',
                icon: UsersIcon,
                isMain: true,
                items: [
                    {
                        name: 'Alerts',
                        link: '/admin/alerts',
                        icon: AlertIcon,
                        activeIcon: AlertActiveIcon,
                        secret: 16,
                    },
                    {
                        name: 'Payments',
                        link: '/admin/payments',
                        icon: SuitCase,
                        activeIcon: SuitCaseActive,
                        secret: 18,
                    },
                    {
                        name: 'Promotions',
                        link: '/admin/promos',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 7,
                    },
                    {
                        name: 'Users',
                        link: '/admin/users',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 8,
                    },
                    {
                        name: 'Airline Copy',
                        link: '/admin/airline-copy',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 9,
                    },
                    {
                        name: 'Tracking Copy',
                        link: '/admin/tracking-copy',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 10,
                    },
                    {
                        name: 'SLA Dashboard',
                        link: '/admin/sla-dashboard',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 15,
                    },
                    {
                        name: 'SLA Audit',
                        link: '/admin/sla-audit',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 15,
                    },
                    {
                        name: 'SLA Capacity View',
                        link: '/admin/sla-capacity-view',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 15,
                    },
                    {
                        name: 'Test Bookings',
                        link: '/admin/test-bookings',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 99,
                    },
                ],
            },
        ],
    },
    {
        heading: 'SuperAdmin',
        items: [
            {
                name: 'Super Admin',
                link: '/super-admin',
                icon: UsersIcon,
                isMain: true,
                items: [
                    {
                        name: 'Bookings view',
                        link: 'super-admin/booking-view',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 14,
                    },
                    {
                        name: 'Bookings action',
                        link: 'super-admin/booking-actions',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 13,
                    },
                    {
                        name: 'View Passport',
                        link: 'super-admin/view-passports',
                        icon: UserIcon,
                        activeIcon: UserActiveIcon,
                        secret: 14,
                    },
                ],
            },
        ],
    },
];

export default menuItems;
